<template>
    <div class="ioRecord">
      <div class="right">
        
        <div class="searchbox">
          <form action="#" method="get" class="form-inline form-float">
            <div class="form-group">
              <el-select v-model="search.pid" placeholder="请选择商户分类">
            <el-option
              v-for="item in allMerchant"
              :key="item.id"
              :label="item.merchantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
            </div>
            <div class="form-group">
              <el-input v-model="search.merchantName"></el-input>
            </div>
            <div class="form-group others">
              <span class="search_btn">
                <button
                  @click="searchList"
                  type="button"
                  class="btn btn-primary"
                  id="search_btn"
                 :disabled="loading">
              <i v-if="loading" class="el-icon-loading"></i>
              {{ loading ? "查询中..." : "查询" }}
            </button>
              </span>
              <span class="add_btn">
                <button
                  type="button"
                  class="btn btn-default"
                  id="add"
                  @click="addDialog()"
                >
                  添加
                </button>
              </span>
            </div>
          </form>
        </div>
        <template>
          <div v-show="showList" class="list-right">
            <el-table v-loading="loading" element-loading-text="加载中..."
              ref="table"
              border
              :data="tableListData"
              height="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
            >
              <el-table-column
                show-overflow-tooltip
                label="商户名称"
                prop="merchantName"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="联系人"
                prop="contacts"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="联系电话"
                prop="telephone"
              ></el-table-column>
  
              <el-table-column
                show-overflow-tooltip
                label="分类图片"
                prop="picture"
              >
                <span slot-scope="scope">
                  <button
                  :style="{margin:'5px',padding:'0 10px','box-sizing': 'border-box',cursor:!scope.row.picture?'not-allowed':'pointer'}"
                    type="primary;"
                    @click="onImgPreviewClick(scope.row)"
                    :disabled="!scope.row.picture"
                  >
                预览图片
                </button>
                </span>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="跳转url"
                prop="url"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="添加时间"
                prop="updTime"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="备注"
                prop="remark"
              ></el-table-column>
              <el-table-column show-overflow-tooltip label="操作" width="250px">
                <template slot-scope="scope">
                  <button
                    type="button"
                    class="edit"
                    @click="editDialog(scope.row)"
                  >
                    修改
                  </button>
                  <button class="delete" @click="del(scope.row.id)">删除</button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>
      <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
      <promotional-discounts-add
        v-if="showAddDialog"
        v-on:closeDialog="closeDialog"
      ></promotional-discounts-add>
      <promotional-discounts-edit
        :detail="currentRow"
        v-if="showEditDialog"
        v-on:closeDialog="closeDialog"
      ></promotional-discounts-edit>
      <el-image-viewer
        v-if="imgViewerVisible"
        :on-close="closeImgViewer"
        :url-list="[currentImgRow.picture]"
      >
      </el-image-viewer>
    </div>
  </template>
    
    <script>
  import { mapState, mapMutations } from "vuex";
  import { merchantClassList,merchantClassCud ,merchantClassAll} from "@/api/url";
  import Page from "@/page/commons/page";
  import dayjs from "dayjs";
  import PromotionalDiscountsAdd from "./promotional-discounts-add.vue";
  import PromotionalDiscountsEdit from "./promotional-discounts-edit.vue";
  import elImageViewer from "element-ui/packages/image/src/image-viewer";
  export default {
    name: "promotional-discounts",
    components: {
      Page,
      PromotionalDiscountsAdd,
      PromotionalDiscountsEdit,
      elImageViewer
    },
    data() {
      return {
      loading: false,
        moduleName: "property",
        styleObj: {
          "text-align": "center",
        },
        tableHeaderStyle: {
          "text-align": "center",
          background: "#F9F9FB",
        },
        groupList: [],
        tableListData: [
        //   {
        //     merchantName: "test",
        //     contacts: "test",
        //     telephone: "test",
        //     picture:
        //       "https://roadside-parking.oss-cn-shenzhen.aliyuncs.com/share_parking/2b8247df91314d64b24b65d603d49063.jpg",
        //     url: "www.baidu.com",
        //     updateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        //     remark: "test",
        //   },
        ],
        tableListDataTitle: [],
        switchValue: "list",
        showList: true,
        showChart: false,
        search: {
          pageSize: 10,
          pageNumber: 1,
          merchantName: "",
          pid:''
        },
     
        currentRow: {},
        showAddDialog: false,
        showEditDialog: false,
        currentImgRow: {},
        imgViewerVisible: false,
        allMerchant:[]
      };
    },
    methods: {
      ...mapMutations(["getPage"]),
      getAllMerchantClass(){
        this.$get(`${merchantClassAll()}`).then((res) => {
         
          this.allMerchant = res??[];
          
        });
      },
      receivePaginationData(v1, v2) {
        this.search.pageNumber = v1;
        this.search.pageSize = v2;
        this.tableList(this.search.pageNumber);
      },
  
      tableList: function (curPage) {
        this.loading = true;
        var _this = this;
        console.log('merchantName=>',this.search.merchantName)
        this.$get(merchantClassList(), {
          page: curPage,
          limit: this.search.pageSize,
          merchantName: this.search.merchantName,
          pid:this.search.pid
        }).then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
          _this.$nextTick(() => {
            _this.$refs.table.doLayout();
          });
        }).finally(() => {
        this.loading = false;
      });
},
  
      searchList: function () {
        if (this.loading) return;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      },
      closeDialog(type) {
        this.showAddDialog = false;
        this.showEditDialog = false;
        if (type == "add") {
          this.search.pageNumber = 1;
          this.tableList(this.search.pageNumber);
        }
        if (type == "edit") {
          this.tableList(this.curIndex);
        }
      },
      addDialog() {
        this.showAddDialog = true;
      },
      editDialog(row) {
        this.showEditDialog = true;
        this.currentRow = { ...row };
      },
      del(id) {
        var _this = this;
        var index = _this.$layer.confirm(
          "您确定删除？",
          {
            btn: ["确定", "取消"],
            shade: false,
            type: 0,
          },
          function () {
            _this.$layer.close(index);
            _this
              .$deleteRequest(merchantClassCud() + "/" + id)
              .then((data) => {
                if (data.status != 200)
                  return _this.$layer.msg("删除失败", { time: 1 });
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "删除成功!",
                });
                _this.tableList(_this.curIndex);
              });
          }
        );
      },
      onImgPreviewClick(row) {
        this.imgViewerVisible = true;
        this.currentImgRow = { ...row };
        console.log(row);
      },
      closeImgViewer() {
        this.imgViewerVisible = false;
      },
    },
    computed: {
      ...mapState({
        curIndex: (state) => state.page.curIndex,
        rowsCount: (state) => state.page.rowsCount,
        nodeData: (state) => state.nodeData,
        nod: (state) => state.nod,
      }),
    },
    mounted() {
      this.search.pageNumber=1
      this.tableList(1);
      this.getAllMerchantClass()
    },
  };
  </script>
    
    <style scoped>
  .table tr td {
    text-align: center;
  }
  
  .modal-body .tab-img li {
    width: 100px;
    height: 100px;
    margin: 10px 10px;
  }
  .table thread tr td {
    text-align: center;
  }
  .pagbox {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
  .searchbox {
    background: #f9f9fb;
    border-bottom: 10px solid #eff2f7;
  }
  .form-inline {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    align-items: center;
    height: 90px;
  }
  .search_btn,
  .download_btn,
  .refresh_btn {
    display: inline-block;
  }
  .refresh_btn {
    display: -webkit-flex;
    display: flex;
    align-items: center;
  }
  .others {
    display: -webkit-flex;
    display: flex;
    justify-content: center;
  }
  #myChart {
    overflow-x: auto;
  }
  .form-group .switchGroup {
    margin-left: 50px;
    display: flex;
    align-items: center;
    width: 16px;
  }
  .switch-info {
    display: inline-block;
    margin-left: 5px;
    width: 16px;
  }
  .show-list {
    height: 500px;
  }
  
  </style>
    <style>
  
  .switchGroup .el-input__inner {
    border: 1px solid #67c23a;
    border-radius: 4px;
  }
  .download_btn {
    display: inline-block;
    margin-left: 15px;
  }
  </style>